import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import SubgroupFormFields from "./SubgroupFormFields.js";


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            padre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
        buttonClass: PropTypes.string
    }

    setSelects(data) {
        this.setState({
            padre_id: data.padre_id,
        });
    }

    ResetForm() {
        this.setState({
            padre_id: null,
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.subgrupos.edit}
                postUrl={api.usuarios.subgrupos.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Subgrupo ha sido editado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                buttonTitle={"Editar Subgrupo"}
                title={"Editar Subgrupo"}
                buttonIcon={"fa fa-pencil fa-lg"}

                saveButton={true}
                closeButton={true}
                buttonClass={this.props.buttonClass}
                className={"ui-modal-dialog ui-modal-md"}

                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
            >
                <div className="ui-form">
                    <SubgroupFormFields
                        padreId={this.state.padre_id}
                        onGrupoChange={(data) => this.setState({ padre_id: (data != null ? data.pk : 0) })} />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Subgrupos/Edit.js